import React from "react";
import { connect } from "react-redux";
import { IPrivateWallets } from "@funds/components/WithdrawAmount/IWithdrawAmount";
import { TReducers } from "@features/reducers";
import { IWithdrawFees } from "@funds/components/WithdrawForm/IWithdrawForm";
import WithdrawAmount from "./parts/WithdrawAmount/WithdrawAmount";
import { IWalletDetails } from "@market/interfaces/IWallet";

type Props = {
  currency: string;
  cryptoWallets: IPrivateWallets[];
  userWallet: IWalletDetails;
  fiatRestrictedCountries: string[];
  fiatWithdrawalBlocked: number;
  fees: IWithdrawFees[];
  exchangeRate: number | undefined;
};

export const CryptoForm = (props: Props) => {
  const { currency, userWallet, cryptoWallets, exchangeRate } = props;

  return (
    <WithdrawAmount
      currency={currency}
      cryptoWallets={cryptoWallets}
      userWallet={userWallet}
      fees={props.fees}
      exchangeRate={exchangeRate}
    />
  );
};

const mapStateToProps = (store: TReducers, ownProps: Props) => {
  return {
    userWallet: (store.fundsReducer.supportedUserWallets || []).filter(
      (el) => el.currency === ownProps.currency
    )[0],
    cryptoWallets: (store.fundsReducer.cryptoWallets || []).filter(
      (el) => el.supported_withdraw_currency === ownProps.currency
    ),
    fiatRestrictedCountries: store.appSettings.fiat_restricted_countries,
    fiatWithdrawalBlocked: store.appSettings.fiat_withdraw_blocked,
  };
};

export default connect(mapStateToProps)(CryptoForm) as any;
